import styled from 'styled-components';
import { types } from '../../../libs/themes';

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  padding: 20px 30px 10px 30px;
  margin-left: 20px;
`;

export const BackArrow = styled.span`
  cursor: pointer;
  ${types.body.secondaryTitle}
  display: flex;
  align-items: center;
`;

export const TitleContainer = styled.span`
 ${types.headers.main42}
 line-height: normal;
 color: ${({ theme }) => theme.modalColor};
`;

export const VideoCount = styled.span`
   ${types.headers.itemMedium}
  color: ${({ theme }) => theme.modalSubText};
  margin-left: 10px;
`;

export const ScrollableContent = styled.div`
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  padding-left: 30px;
`;

export const MediaGrid = styled.div`
  position: relative;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
`;
